import React from 'react';

import LazyImgixImage from '@components/LazyImgixImage';
import { project_path } from '@routes';
import { getImgixSrc } from '@utils/images';

interface CategoryHeaderImageProps {
  hasHoverImage: boolean;
  imageName: string;
  projectSlug: string;
}

const CategoryHeaderImage = ({
  hasHoverImage,
  imageName,
  projectSlug,
}: CategoryHeaderImageProps) => {
  return (
    <>
      <LazyImgixImage
        role="presentation"
        className={hasHoverImage ? 'normal-state' : 'category-image'}
        visibleByDefault={true}
        src={getImgixSrc({
          path: `${project_path(projectSlug)}/categories/${imageName}.svg`,
          isEnvDependent: false,
        })}
      />
      {hasHoverImage && (
        <LazyImgixImage
          role="presentation"
          className="hover-state-image"
          visibleByDefault={true}
          src={getImgixSrc({
            path: `${project_path(projectSlug)}/categories/Hover_${imageName}.svg`,
            isEnvDependent: false,
          })}
        />
      )}
    </>
  );
};

export default CategoryHeaderImage;
